import { IErrorRes } from '@remote/type'
import { request } from './request'

export const getDir = async (space: string, parentID?: string) => {
  const [err, data]: [IErrorRes, API_FILE.DriveListFilesResponse] = await request('/drive/v1/files', {
    space,
    parent_id: parentID ?? '',
    filters: JSON.stringify({ kind: { eq: 'drive#folder' } }),
  })
  if (!err) {
    return data
  }
}

export const getHeziSpace = async (space = 'SPACE_HEZI', withQuotas: string = 'CREATE_OFFLINE_TASK_LIMIT',) => {
  const [err, data]: [IErrorRes, {
    quota: {limit: string, usage:string}
  }] = await request(
    '/drive/v1/about', space ? {
      with_quotas: withQuotas,
      space
    } : {
    with_quotas: withQuotas
  }, {apiEnv: 'production'})
  if (!err) {
    return data
  }
}
